// import ArrowRightWhite from "@/app/assets/icons/arrow-right-white";
import Bulb from "@/app/assets/icons/bulb";
import ICMWrapper from "@/app/components/icm-wrapper";
import Feat1 from "@/app/assets/images/ue-feat1.png";
import Feat2 from "@/app/assets/images/ue-feat2.png";
import Feat3 from "@/app/assets/images/ue-feat3.png";
import Feat4 from "@/app/assets/images/ue-feat4.png";
import Feat5 from "@/app/assets/images/ue-feat5.png";
// import Feat6 from "@/app/assets/images/ue-feat6.png";
import Feat7 from "@/app/assets/images/ue-feat7.png";
import Feat8 from "@/app/assets/images/ue-feat8.png";
import Feat9 from "@/app/assets/images/ue-feat9.png";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
// import { IconButton } from "@/stories/icon-button/icon-button";
import React, { useState } from "react";
import Image, { StaticImageData } from "next/image";
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
// import { DirectPaths } from "@/config/routes";

interface WhyUEProps {
    title: string;
    subtitle: string;
    image: StaticImageData;
    iconAlt: string;
}

interface Benefits {
    title: string;
    subtitle: string;
}

export default function WhyUnlistedShares() {
    const [viewAll, setViewAll] = useState<boolean>(false);

    const WhyUE: WhyUEProps[] = [
        {
            title: "Not traded on stock exchanges",
            subtitle:
                "These shares are not listed on NSE or BSE and are traded privately between buyers and sellers.",
            image: Feat1,
            iconAlt: "",
        },
        {
            title: "Ownership in pre-IPO or private companies",
            subtitle:
                "Invest in companies before they go public and gain early ownership in their growth journey.",
            image: Feat2,
            iconAlt: "",
        },
        {
            title: "Transactions happen through private deals",
            subtitle:
                "Buying and selling is facilitated through specialized platforms.",
            image: Feat3,
            iconAlt: "",
        },
        {
            title: "Lower liquidity",
            subtitle:
                "Selling these shares may take longer due to buyer and seller availability.",
            image: Feat4,
            iconAlt: "",
        },
        {
            title: "Limited public information",
            subtitle:
                "Unlisted companies disclose less financial data compared to listed companies, making research more important.",
            image: Feat5,
            iconAlt: "",
        },
        // {
        //     title: "Prices are negotiated",
        //     subtitle:
        //         "Prices are not market-driven and are determined through private negotiations based on demand and company performance.",
        //     image: Feat6,
        //     iconAlt: "",
        // },
        {
            title: "Early-stage growth opportunity",
            subtitle:
                "Investors can participate in companies at an early stage and benefit from future growth or IPO events.",
            image: Feat7,
            iconAlt: "",
        },
        {
            title: "Held in demat form",
            subtitle:
                "Once purchased, shares are credited to your demat account.",
            image: Feat8,
            iconAlt: "",
        },
        {
            title: "Indicative price tracking available",
            subtitle:
                "Platforms provide estimated and historical price ranges.",
            image: Feat9,
            iconAlt: "",
        },
    ];

    const benefits: Benefits[] = [
        {
            title: "Access Before Listing",
            subtitle: "Invest in companies before they are listed.",
        },
        {
            title: "Beyond Public Markets",
            subtitle: "Explore opportunities not available through stock exchanges.",
        },
        {
            title: "Built for Long-Term Investors",
            subtitle:
                "Suitable for investors looking to participate in a company's growth journey over time.",
        },
    ];

    return (
        <div className="bg-neutral-800">
            <ICMWrapper>
                <section
                    className="flex flex-col items-center py-s15 md:py-s18"
                    aria-labelledby="why-invest-heading"
                >
                    <h2
                        id="why-invest-heading"
                        className="mb-14 text-center text-4xl font-semibold -tracking-[0.56px] text-white md:mb-20 md:text-7xl md:leading-[67.2px]"
                    >
                        What are Unlisted Shares?
                    </h2>
                    <ul className="mb-16 flex list-none flex-col items-center justify-evenly gap-20 md:flex-row md:flex-wrap">
                        {WhyUE.map((item, index) => {
                            if (index > 5 && !viewAll) {
                                return null;
                            }

                            return (
                                <li
                                    key={index}
                                    className="flex flex-col items-center justify-center align-middle sm:w-1/4"
                                >
                                    <div className="mb-7">
                                        <Image
                                            src={item.image}
                                            height={84}
                                            width={84}
                                            alt={item.iconAlt}
                                        />
                                    </div>
                                    <h3 className="mb-2 text-center text-xl font-semibold leading-[130%] tracking-[0%] text-white">
                                        {item.title}
                                    </h3>
                                    <p className="text-center text-sm font-regular leading-[160%] tracking-[1%] text-[#FFFFFFCC]">
                                        {item.subtitle}
                                    </p>
                                </li>
                            );
                        })}
                    </ul>

                    <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className="w-full max-w-full border-neutralOpacityLight-30 text-white hover:text-black md:max-w-fit"
                        label={viewAll ? "View Less" : "View All"}
                        onClick={() => {
                            setViewAll((val) => !val);
                        }}
                    />
                </section>
            </ICMWrapper>
            <div className="bg-ue-hero-background">
                <ICMWrapper>
                    <div className="flex flex-wrap items-center justify-between py-s13">
                        <div className="flex items-center md:mb-0">
                            <div className="mr-6 flex h-12 w-12 flex-col items-center justify-center rounded-full bg-gray-700 p-[10px] md:h-[60px] md:w-[60px]">
                                <Bulb className="text-white" />
                            </div>
                            <h4 className="text-nowrap text-lg font-semibold leading-[23.4px] text-white md:w-1/2">
                                Why Invest in Unlisted Shares?
                            </h4>
                        </div>

                        <ul className="mt-10 flex list-none gap-[15px] overflow-x-auto scrollbar-hide md:mt-0 md:gap-20">
                            {benefits.map((item, index) => (
                                <li key={index} className="w-1/3 sm:max-w-[200px] sm:w-auto">
                                    <p className="text-sm font-medium leading-[22.4px] tracking-[0.12px] text-neutralOpacityLight-80 mb-2 sm:mb-0">
                                        {item.title}
                                    </p>
                                    <p className="text-xs font-medium leading-4 sm:leading-[22.4px] tracking-[0.12px] text-neutralOpacityLight-80">
                                        {item.subtitle}
                                    </p>
                                </li>
                            ))}
                        </ul>
                        {/* <IconButton
                            icon={<ArrowRightWhite className="hover:text-black" />}
                            size={ButtonSize.Small}
                            variant={ButtonVariant.SecondaryDefault}
                            className="hidden border-neutralOpacityLight-10 md:flex"
                            onClick={() => {
                                const redirect = process.env.ICM_UE_POST_URL + "/login";
                                setAnalyticsEvent(
                                    `${redirect}`,
                                    "US_Listing_Page_How_is_Unlisted_Shares_different_section_Arrow",
                                );
                                window.location.href = `${redirect}`;
                            }}
                        /> */}
                    </div>
                </ICMWrapper>
            </div>
        </div>
    );
}
